import React, { useState } from 'react';
import { API_BASE_URL } from './config';

function Login({ onLogin }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();

    const response = await fetch(`${API_BASE_URL}/api/token/`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ username, password })
    });

    const data = await response.json();

    if (response.ok) {
      localStorage.setItem('access', data.access);
      localStorage.setItem('refresh', data.refresh);
      onLogin();
    } else {
      setError(data.detail || 'Login failed');
    }
  };

  return (
    <div style={{
      maxWidth: 400,
      margin: '100px auto',
      padding: 20,
      fontFamily: 'sans-serif'
    }}>
      <div style={{
        textAlign: 'center',
        position: 'relative',
        marginBottom: '32px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'flex-start',
      }}>
        <div style={{ position: 'relative', display: 'inline-block' }}>
          <img
            src="/static/img/monk.svg"
            alt="Djedjuler"
            style={{ height: '80px', maxWidth: '100%', margin: '0 auto', display: 'block' }}
          />
          <div style={{
            position: 'absolute',
            bottom: '10px',
            left: '85%',
            transform: 'translateX(-50%) rotate(-20deg)',
            backgroundColor: 'red',
            color: 'white',
            fontWeight: 'bold',
            padding: '2px 8px',
            fontSize: '12px',
            boxShadow: '0 2px 5px rgba(0,0,0,0.3)',
            whiteSpace: 'nowrap',
          }}>
            djedjuler
          </div>
        </div>
      </div>
      {error && <div style={{ color: 'red', marginBottom: 10 }}>{error}</div>}
      <form onSubmit={handleSubmit}>
        <input
          type="text"
          value={username}
          onChange={e => setUsername(e.target.value)}
          placeholder="Username"
          style={{
            width: '100%',
            padding: '10px',
            marginBottom: '10px',
            fontSize: '14px',
            border: '1px solid #ccc',
            outline: 'none',
            borderRadius: 0
          }}
        />
        <input
          type="password"
          value={password}
          onChange={e => setPassword(e.target.value)}
          placeholder="Password"
          style={{
            width: '100%',
            padding: '10px',
            marginBottom: '10px',
            fontSize: '14px',
            border: '1px solid #ccc',
            outline: 'none',
            borderRadius: 0
          }}
        />
        <button
          type="submit"
          style={{
            width: '106%',
            padding: '12px',
            fontSize: '14px',
            backgroundColor: '#000',
            color: '#fff',
            border: 'none',
            borderRadius: 0,
            cursor: 'pointer',
            fontWeight: '500',
            letterSpacing: '0.5px'
          }}
          className="login-button"
        >
          Login
        </button>
      </form>
    </div>
  );
}

export default Login;
